import React from 'react'
import createReactClass from 'create-react-class'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'

import entryTagApi from 'legacy/api/entry-tag'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import TagSelect from '../tag-select'
import s from '../tag-select/tag-select.module.scss' // <-- SCSS modules

export default createReactClass({
  displayName: 'GroupSelect',

  mixins: [SchemaBranchMixin, FormComponentMixin],

  propTypes: {
    onChange: PropTypes.func,
    service: PropTypes.func.isRequired,
    poll: PropTypes.object,
    createService: PropTypes.func,
    deleteService: PropTypes.func,
    approveService: PropTypes.func,
    refuseService: PropTypes.func,
  },

  // Baobab schema:
  schema: {
    pk: null,
    name: null,
    opened: true,
  },

  // Baobab cursors:
  cursors(props, context) {
    return {
      selectedTags: this.getCursor(props, context),
      rootEntryTagsCursor: props.rootEntryTagsCursor,
    }
  },

  getDefaultProps() {
    return {
      onChange: _.identity,
    }
  },

  // Local React state:
  getInitialState() {
    return {
      searchQuery: '',
      searchResults: [],
      showResults: false,
      loading: false, // <-- single "busy" state
    }
  },

  componentDidMount() {
    // For "click away" logic, we attach a global click listener:
    document.addEventListener('click', this.handleDocumentClick, true)
  },

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, true)
  },

  handleDocumentClick(e) {
    // If user clicked outside, hide the search results
    if (
      this.refs.searchContainer &&
      !this.refs.searchContainer.contains(e.target)
    ) {
      this.setState({ showResults: false })
    }
  },

  onTitleClick() {
    // Toggle the "opened" boolean in Baobab
    this.cursors.opened.apply((x) => !x)
  },

  onSearchFocus() {
    // If there's already a query + results, re-show the overlay
    if (
      this.state.searchQuery.length >= 3 &&
      this.state.searchResults.length > 0
    ) {
      this.setState({ showResults: true })
    }
  },

  onSearchChange(e) {
    const searchQuery = e.target.value
    this.setState({ searchQuery })

    // Only search if 3+ chars
    if (searchQuery.length >= 3) {
      // Show spinner
      this.setState({ loading: true })

      entryTagApi
        .search({ searchText: searchQuery, groupPk: this.state.pk })
        .then((results) => {
          // Check if user hasn't changed the input in the meantime
          if (this.state.searchQuery === searchQuery) {
            this.setState({
              searchResults: results,
              showResults: true,
              loading: false, // done
            })
          }
        })
        .catch(() => {
          this.setState({
            searchResults: [],
            showResults: true,
            loading: false,
          })
        })
    } else {
      // Clear spinner & results if < 3 chars
      this.setState({
        searchResults: [],
        showResults: false,
        loading: false,
      })
    }
  },

  onSelectSearchResult(tag) {
    // Show spinner while we fetch ancestors
    this.setState({ loading: true })

    entryTagApi
      .getAncestors(tag.pk)
      .then((ancestors) => {
        const selected = this.cursors.selectedTags.get()

        // Add each ancestor if not already present
        ancestors.forEach((ancestor) => {
          if (!_.find(selected, { pk: ancestor.pk })) {
            this.cursors.selectedTags.push(ancestor)
          }
        })

        // Add the chosen tag if not present
        if (!_.find(selected, { pk: tag.pk })) {
          this.cursors.selectedTags.push(tag)
        }

        // Mark form as dirty so it can be saved
        this.setDirtyState()

        // Hide results overlay
        this.setState({
          showResults: false,
          // optional: searchQuery: '',
          loading: false, // done
        })
      })
      .catch(() => {
        // On error, still hide spinner
        this.setState({ loading: false })
      })
  },

  renderTitle() {
    const { opened, name, pk } = this.state
    const className = classNames(s.item, {
      [s._opened]: opened,
    })
    const isRequired = _.includes(this.props.poll.requiredEntryTagGroups, pk)

    return (
      <div className={s.wrapper}>
        <span className={className} onClick={this.onTitleClick}>
          <span className={s.title}>{name}</span>
        </span>
        {isRequired ? (
          <span className={classNames(s.title, s.required)}>(required)</span>
        ) : null}
      </div>
    )
  },

  renderSearchBar() {
    const { searchQuery, searchResults, showResults, loading } = this.state

    return (
      <div ref="searchContainer" className={s.searchContainer}>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Type 3+ letters to search tags"
            value={searchQuery}
            onChange={this.onSearchChange}
            onFocus={this.onSearchFocus}
            style={{ width: '80%', padding: '4px' }}
          />

          {/* Show spinner if loading */}
          {loading && (
            <div className={s.spinnerWrapper}>
              <div className={s.spinner} />
            </div>
          )}
        </div>

        {showResults && searchResults.length > 0 && (
          <ul className={s.searchResultsOverlay}>
            {searchResults.map((tag) => (
              <li key={tag.pk} onClick={() => this.onSelectSearchResult(tag)}>
                {tag.name}
                {tag.ancestry?.length && (
                  <span
                    style={{
                      color: '#999',
                      fontSize: '12px',
                      marginLeft: '5px',
                    }}
                  >
                    ({tag.ancestry.join(' / ')})
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    )
  },

  render() {
    const cursors = this.cursors.rootEntryTagsCursor

    return (
      <div className={s.tag}>
        {this.renderTitle()}
        {this.cursors.opened.get() && (
          <div>
            {this.renderSearchBar()}
            {/* The normal TagSelect tree */}
            {cursors.map((cursor, index) => (
              <TagSelect
                tree={cursor}
                cursor={this.cursors.selectedTags}
                key={index}
                entryTagGroupName={this.state.name}
                {..._.pick(this.props, [
                  'onChange',
                  'service',
                  'deleteService',
                  'createService',
                  'approveService',
                  'refuseService',
                ])}
              />
            ))}
          </div>
        )}
      </div>
    )
  },
})
